import {CommonModule} from '@angular/common';
import {Component,Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslocoModule,TranslocoService} from '@ngneat/transloco';

@Component({
    selector: 'app-video',
    templateUrl: './video.component.html',
    imports: [
        CommonModule,
        TranslocoModule
    ]
})
export class VideoComponent {
  @Input() videoUrl: string = '';
  @Input() showPlaybutton: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    public translocoService: TranslocoService,
  ) {
    const lang = this.translocoService.getActiveLang();

    switch (lang) {
      case 'zh-CN':
        this.videoUrl = 'https://app.takeme.com/videos/tmc-cn.mp4';
        break;
      case 'zh-TW':
        this.videoUrl = 'https://app.takeme.com/videos/tmc-tw.mp4';
        break;
      default:
        this.videoUrl = 'https://app.takeme.com/videos/tmc-en.mp4';
    }
  }

  playVideo() {
    const videoElement = document.querySelector('video');
    if (videoElement) {
      videoElement.play();
    }
  }

  close() {
    this.activeModal.close();
  }
}
